import {Pipe, PipeTransform} from '@angular/core';
import {UtilitiesService} from "../../core/_services/utilities.service";

@Pipe({
    name: 'listServices',
    pure: false
})
export class ListServicesPipe implements PipeTransform {

    // any => Vehicle | Job | JobRequest
    transform(services: any[]): string {
        if (UtilitiesService.isNotEmpty(services)) {
            let serviceList = '';

            for (let i = 0; i < services.length; i++) {
                if (i === 0) {
                    serviceList = services[i].name;
                } else {
                    serviceList = serviceList + '<br>' + services[i].name;
                }
            }
            return serviceList;
        }

        return '';
    } // transform()

} // ListServicesPipe
